import React from 'react';
import PropTypes from 'prop-types';

import { mergeClasses } from '@utils';

import MembershipButton from './Membership.Button';
import MembershipHeading from './Membership.Heading';
import MembershipUSP from './Membership.USP';
import MembershipUSPs from './Membership.USPs';

export default function Membership({ className, children, ...restProps }) {
  return (
    <div className={mergeClasses('rounded-lg', className)} {...restProps}>
      <div className="space-y-4">{children}</div>
    </div>
  );
}

Membership.Button = MembershipButton;
Membership.Heading = MembershipHeading;
Membership.USP = MembershipUSP;
Membership.USPs = MembershipUSPs;

Membership.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired
};

Membership.defaultProps = {
  className: ''
};
